import * as React from 'react'

import type { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page } from '@grandvisionhq/www-next/pages/my-account/login'

import withCms from '../../../cms/with-cms'
import withLayout from '../../../cms/with-layout'
import { withCart } from '../../../components/hocs/with-cart'

import '@grandvisionhq/my-account/dist/index.css'

const richText = `
  <h4>¿Todavía no tienes cuenta?</h4>
  <p>Crea una cuenta para agilizar el proceso de tus próximas compras.</p>
  <ul class="checkmark-list">
    <li>Accede a tu perfil para editar tus datos de contacto</a></li>
    <li>Consulta tus pedidos</a></li>
    <li>Actualiza los datos de privacidad</li>
    <li>Si todavía tienes dudas contacta con nosotros</li>
  </ul>
`

const LoginPage: NextPage = () => {
  return <Page richText={richText} />
}

export default compose(withCms(), withLayout(), withCart({ readOnly: true }))(LoginPage)
